export const confirmBeforeLeave = (event) => {
  event.preventDefault();
  event.returnValue = 'Are you sure you want to leave?';
};